import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the insight-settings routes. */
const insightsBase = { permission: ['Manage account'] } satisfies AccessConstraint;

export const insightSettingsAccess = {
  insights: { ...insightsBase },
  notifications: { ...insightsBase, subscriptionPlan: PlanType.PREMIUM },
  targets: { ...insightsBase, subscriptionPlan: PlanType.PREMIUM },
  turnover: { ...insightsBase, subscriptionPlan: PlanType.BASIC },
} satisfies Record<string, AccessConstraint>;
